import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { Actions, Top } from "./components";
import MobileBar from "components/MobileBar";
import PageLoader from "components/PageLoader";
import BackMobile from "components/BackMobile";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "dashboard-layout-content";

const DashboardContentLayout = ({
  variant,
  backMobile,
  header,
  children,
  aside,
  loading,
  actions,
  showActionsMobile,
  isAdaptive,
}) => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const isBordered = !!header?.label || header?.async;

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--bordered`]: isBordered,
        [`${mainClass}--adaptive`]: isAdaptive && !loading,
        [`${mainClass}--${variant}`]: variant,
      })}
    >
      {!max.sm ? <Top actions={actions} /> : <MobileBar />}
      {max.sm &&
        (typeof backMobile === "function" ||
          (actions?.length > 0 && showActionsMobile)) && (
          <div className={`${mainClass}__actions-mobile`}>
            {typeof backMobile === "function" && (
              <BackMobile onClick={backMobile} />
            )}
            {showActionsMobile && <Actions data={actions} />}
          </div>
        )}
      <div className={`${mainClass}__wrapper`}>
        <div className={`${mainClass}__body`}>
          {isBordered && (
            <div className={`${mainClass}__header`}>
              <div className={`${mainClass}__header-text`}>
                {header?.label?.children ? (
                  <div className={`${mainClass}__header-custom`}>
                    {header.label.children}
                  </div>
                ) : (
                  <h1
                    className={classnames({
                      action:
                        !!header?.label?.onClick && !(header?.async && loading),
                    })}
                    onClick={
                      header?.label?.onClick
                        ? () => header.label.onClick()
                        : undefined
                    }
                  >
                    {header?.label && !(header?.async && loading) ? (
                      typeof header.label === "string" ? (
                        header.label
                      ) : (
                        header.label.value
                      )
                    ) : (
                      <span className={`${mainClass}__header-async`}>
                        <span />
                      </span>
                    )}
                  </h1>
                )}
                {header?.description && (
                  <div>
                    {header?.async && loading ? (
                      <span
                        className={`${mainClass}__header-async ${mainClass}__header-async--small`}
                      >
                        <span />
                      </span>
                    ) : typeof header.description === "object" ? (
                      header.description.onClick ? (
                        <button
                          type="button"
                          onClick={header.description.onClick}
                        >
                          {header.description?.value ?? t("Action")}
                        </button>
                      ) : null
                    ) : (
                      <p>{header.description}</p>
                    )}
                  </div>
                )}
              </div>
              {header?.actions && (
                <div className={`${mainClass}__header-actions`}>
                  {header.actions}
                </div>
              )}
              {header?.aside && (
                <div className={`${mainClass}__header-aside`}>
                  {header.aside}
                </div>
              )}
            </div>
          )}
          {!!loading ? <PageLoader variant="panel" /> : children}
        </div>
        {!!aside && <div className={`${mainClass}__aside`}>{aside}</div>}
      </div>
    </div>
  );
};

export default DashboardContentLayout;
